import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EditCategoryForm } from '../../../../components/admin-dashboard-component/categories/edit-category-form/edit-category-form';

@Component({
  selector: 'app-edit-category',
  imports: [EditCategoryForm],
  templateUrl: './edit-category.html',
  styleUrl: './edit-category.scss',
})
export class EditCategory implements OnInit {
  categoryId: number | null = null;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const id = this.route.snapshot.params['id'];
    this.categoryId = id ? +id : null;
  }
}
